import _classCallCheck from "D:\\a\\1\\s\\Ktm.Configurator.Web\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\a\\1\\s\\Ktm.Configurator.Web\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import { Observable } from "rxjs";
import { InteractionInputEventHandler, LockingInputEventHandler } from "./internal/input-event-handlers";
import { InputEventSource } from "./internal/input-event-source";
var ZOOM_TRANSMIT_COOLDOWN_INTERVAL = 15;
export var StreamingControlService =
/*#__PURE__*/
function () {
  function StreamingControlService() {
    _classCallCheck(this, StreamingControlService);
  }

  _createClass(StreamingControlService, [{
    key: "createOptions",
    value: function createOptions(streamInfo) {
      var options = {
        controlServerOptions: {
          enable: !!streamInfo.specs.useRendererControl,
          host: streamInfo.specs.publicDomainName,
          port: streamInfo.specs.Port,
          path: streamInfo.specs.rendererControlPath
        },
        inputOptions: {}
      };

      if (streamInfo.specs.rendererControlLock) {
        options.inputOptions = {
          lockMouse: true
        };
      }

      return options;
    }
  }, {
    key: "connect",
    value: function connect(videoElement, options) {
      var _this = this;

      this.options = options;
      this.videoElement = videoElement;
      this.close();
      return new Observable(function (observer) {
        var _a;

        if (!_this.options.controlServerOptions.host || !_this.options.controlServerOptions.port) {
          observer.next(false);
          observer.complete();
          return;
        }

        var port = _this.TryParseInt(_this.options.controlServerOptions.port, 0);

        if (port == 0) {
          observer.next(false);
          observer.complete();
          return;
        }

        if (!_this.options.controlServerOptions.path) {
          _this.options.controlServerOptions.path = "ws";
        }

        _this.eventSource = new InputEventSource(videoElement, _this.options.inputOptions);
        if ((_a = _this.options.inputOptions) === null || _a === void 0 ? void 0 : _a.lockMouse) _this.eventHandler = new LockingInputEventHandler(videoElement, _this, _this.eventSource, _this.options.inputOptions);else _this.eventHandler = new InteractionInputEventHandler(videoElement, _this, _this.eventSource, _this.options.inputOptions);
        _this.observer = observer;
        var uri = "wss://".concat(_this.options.controlServerOptions.host, ":").concat(port, "/").concat(_this.options.controlServerOptions.path);
        _this.socket = new WebSocket(uri);

        _this.socket.onopen = function (e) {
          return _this.onOpen(e);
        };

        _this.socket.onclose = function (e) {
          return _this.onClose(e);
        };

        _this.socket.onmessage = function (e) {
          return _this.onMessage(e);
        };

        _this.socket.onerror = function (e) {
          return _this.onError(e);
        };
      });
    }
  }, {
    key: "close",
    value: function close() {
      var _a;

      (_a = this.eventSource) === null || _a === void 0 ? void 0 : _a.stopInput();

      if (this.socket) {
        this.socket.close();
        this.socket = null;
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      this.send({
        type: "buttonclear"
      });
      this.send({
        type: "keyclear"
      });
    }
  }, {
    key: "click",
    value: function click(x, y, button) {
      var normalized = this.normalizeCoordinates(x, y);
      this.send({
        type: "click",
        x: normalized[0],
        y: normalized[1],
        button: button
      });
    }
  }, {
    key: "mouseDown",
    value: function mouseDown(x, y, button, noMove) {
      if (noMove) {
        this.send({
          type: "buttondown",
          x: 0,
          y: 0,
          button: button,
          noMove: noMove
        });
      } else {
        var normalized = this.normalizeCoordinates(x, y);
        this.send({
          type: "buttondown",
          x: normalized[0],
          y: normalized[1],
          button: button,
          noMove: noMove
        });
      }
    }
  }, {
    key: "mouseUp",
    value: function mouseUp(x, y, button, noMove) {
      if (noMove) {
        this.send({
          type: "buttonup",
          x: 0,
          y: 0,
          button: button,
          noMove: noMove
        });
      } else {
        var normalized = this.normalizeCoordinates(x, y);
        this.send({
          type: "buttonup",
          x: normalized[0],
          y: normalized[1],
          button: button,
          noMove: noMove
        });
      }
    }
  }, {
    key: "keyDown",
    value: function keyDown(key) {
      this.send({
        type: "keydown",
        key: key
      });
    }
  }, {
    key: "keyUp",
    value: function keyUp(key) {
      this.send({
        type: "keyup",
        key: key
      });
    }
  }, {
    key: "move",
    value: function move(x, y, delta) {
      if (delta) {
        this.send({
          type: "move",
          x: x,
          y: y,
          delta: true
        });
      } else {
        var normalized = this.normalizeCoordinates(x, y);
        this.send({
          type: "move",
          x: normalized[0],
          y: normalized[1],
          delta: false
        });
      }
    }
  }, {
    key: "zoom",
    value: function zoom(delta) {
      var now = new Date().getTime();

      if (this.lastZoomTransmit && ZOOM_TRANSMIT_COOLDOWN_INTERVAL > now - this.lastZoomTransmit) {
        return;
      }

      this.lastZoomTransmit = now;
      this.send({
        type: "zoom",
        delta: delta
      });
    }
  }, {
    key: "send",
    value: function send(data) {
      this.socket.send(JSON.stringify(data));
    }
  }, {
    key: "onOpen",
    value: function onOpen(event) {
      this.observer.next(true);
      this.observer.complete();
    }
  }, {
    key: "onClose",
    value: function onClose(event) {
      if (event.wasClean) {
        console.log("Websocket connection closed cleanly, code=".concat(event.code, " reason=").concat(event.reason));
      } else {
        console.log('Websocket connection died');
      }

      this.cleanUp();
    }
  }, {
    key: "onError",
    value: function onError(error) {
      var _a;

      console.log("Error in websocket connection: " + error);
      (_a = this.observer) === null || _a === void 0 ? void 0 : _a.error(error);
    }
  }, {
    key: "onMessage",
    value: function onMessage(_) {}
  }, {
    key: "cleanUp",
    value: function cleanUp() {
      var _a;

      this.socket = null;
      (_a = this.observer) === null || _a === void 0 ? void 0 : _a.complete();
      this.observer = null;
    }
  }, {
    key: "normalizeCoordinates",
    value: function normalizeCoordinates(x, y) {
      var video = this.videoElement;
      var width = video.videoWidth;
      var height = video.videoHeight;
      var normalizedX = x / width;
      var normalizedY = y / height;
      return [normalizedX, normalizedY];
    }
  }, {
    key: "TryParseInt",
    value: function TryParseInt(str, defaultValue) {
      var retValue = defaultValue;

      if (str !== null) {
        if (str.length > 0) {
          var val = Number(str);

          if (!isNaN(val)) {
            retValue = val;
          }
        }
      }

      return retValue;
    }
  }]);

  return StreamingControlService;
}();